
import React, { useState, useEffect } from 'react';
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { useIsMobile } from '@/hooks/use-mobile';
import SectionLayout from './SectionLayout';
import FeatureSection from './features/FeatureSection';
import MobileFeatureTabs from './features/MobileFeatureTabs';
import DesktopFeatureTabs from './features/DesktopFeatureTabs';
import { featureSections } from './features/featureData';

const MainFeatures = () => {
  const [activeTab, setActiveTab] = useState("ai-assistants"); // Changed default from "intelliforms" to "ai-assistants"
  const isMobile = useIsMobile();
  
  console.log("Active tab in MainFeatures:", activeTab);
  
  // Ensure the default tab is set to ai-assistants on component mount
  useEffect(() => {
    setActiveTab("ai-assistants");
  }, []);
  
  return (
    <SectionLayout backgroundColor="bg-white" paddingY="py-12 md:py-16" className="relative">
      <div className="absolute inset-0 bg-[#003a70]/10 z-0"></div>
      
      <div className="relative z-10 max-w-5xl mx-auto">
        <div className="text-center mb-5 md:mb-10 px-3 sm:px-0">
          <h2 className="text-xl md:text-2xl lg:text-4xl font-bold text-[#003a70] mb-1.5 md:mb-4">Our Powerful Features</h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our suite of AI-powered tools designed to transform how you engage with customers and automate workflows.
          </p>
        </div>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <div className="flex justify-center mb-4 md:mb-10 px-2 sm:px-0">
            {isMobile ? (
              <MobileFeatureTabs 
                sections={featureSections} 
                activeTab={activeTab} 
                onTabChange={setActiveTab} 
              />
            ) : (
              <DesktopFeatureTabs 
                sections={featureSections} 
                activeTab={activeTab} 
              />
            )}
          </div>
          
          {featureSections.map((section) => (
            <TabsContent 
              key={section.id} 
              value={section.id}
              className="outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
            >
              <FeatureSection
                index={featureSections.findIndex(s => s.id === section.id) + 1}
                title={section.subtitle}
                description={section.description}
                imagePlaceholder={section.imagePlaceholder}
                features={section.features}
                ctaText={section.ctaText}
                id={section.id}
              />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </SectionLayout>
  );
};

export default MainFeatures;
